/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Selectedinterviewslotid4Inputs */



/**

* @param {_Field_Selectedinterviewslotid4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_selectedinterviewslotid4 = /** @type {((inputs?: _Field_Selectedinterviewslotid4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Selectedinterviewslotid4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Termin für das Bewerbungsgespräch")
});
export { _field_selectedinterviewslotid4 as "_field_selectedInterviewSlotID" }